import { render, staticRenderFns } from "./GTag.vue?vue&type=template&id=5a7d1e15&"
import script from "./GTag.vue?vue&type=script&lang=ts&"
export * from "./GTag.vue?vue&type=script&lang=ts&"
import style0 from "./GTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports